import { CommonModule } from '@angular/common';
import {
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { AxsButtonComponent } from '@vanguard/axs-angular';
import { ButtonTheme, ModalFunctions } from '@vanguard/axs-core';
import { ContentService } from 'src/app/shared/services/content/content.service';
import { content } from 'src/assets/content/fallback-content';

export interface ModalData {
  index: number;
  title: string;
  name: string;
  clientProfile: string;
  conversionReasoning: string;
  calculatorExplanation: string;
  imgPath: string;
  imgPathCard: string;
}

@Component({
  selector: 'sample-client-modal',
  standalone: true,
  imports: [CommonModule, AxsButtonComponent],
  templateUrl: './sample-client-modal.component.html',
  styleUrl: './sample-client-modal.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SampleClientModalComponent implements OnChanges {
  @Input() modalData: ModalData;
  @Input() isOpen = false;

  @Output() isOpenChange = new EventEmitter<boolean>();
  @Output() loadClient = new EventEmitter<number>();

  @ViewChild('modal') modal: any;
  @ViewChild('dialog') dialog: any;

  commonContent = content.Data.v4_rcc_root.content.common;
  sampleClientModalContent =
    content.Data.v4_rcc_root.content.sampleClientsSection.sampleClientModals;
  contentVisible = false;

  constructor(private readonly contentService: ContentService) {
    this.initializeContent();
  }

  initializeContent() {
    this.contentService.getContent().subscribe((data) => {
      this.sampleClientModalContent =
        data.Data.v4_rcc_root.content.sampleClientsSection?.sampleClientModals;
      this.commonContent = data.Data.v4_rcc_root.content.common;
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['isOpen']?.currentValue) {
      this.contentVisible = false;
      setTimeout(() => this.openModal(), 0);
    }
  }

  openModal(): void {
    (this.modal.nativeElement as ModalFunctions).proxyShowModal();
    const modalContent = this.dialog.nativeElement.querySelector('.sample-client-modal__content');
    if (modalContent) {
      setTimeout(() => {
        this.contentVisible = true;
        modalContent.scrollTop = 0;
      }, 100);
    }
    this.dialog.nativeElement.addEventListener(
      'close',
      () => {
        this.onModalClosed();
      },
      { once: true },
    );
  }

  closeModal(): void {
    if (!this.isOpen) {
      return;
    }
    (this.modal.nativeElement as ModalFunctions).proxyClose();
  }

  onModalClosed(): void {
    this.contentVisible = false;
    this.isOpen = false;
    this.isOpenChange.emit(false);
  }

  onLoadClient(): void {
    if (this.modalData) {
      this.loadClient.emit(this.modalData.index);
      this.closeModal();
    }
  }

  protected readonly ButtonTheme = ButtonTheme;
}
